import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// Components
import { Input } from 'components/Controls';
import { IconButton } from 'components/Buttons';
import { Tooltip } from 'components/Tooltip';
import Icon from 'components/Icon';

type Props = {
  name: string;
  onRemove: () => void;
  idx: number;
};

const Answer:FC<Props> = ({
  // Props
  name, onRemove, idx
}) => {
  const { control } = useFormContext();

  return (
    <div className="flex gap-4">
      <Controller
        control={control} name={`${name}.title`}
        render={({ field }) => (
          <Input
            {...field}
            className="mb-4 w-full"
            label={`Answer ${idx + 1}`} id={`${name}.title`}
          />
        )}
      />
      <div>
        <span className="block mb-1 h-5"></span>
        <Tooltip title="Remove answer">
          <IconButton
            onClick={onRemove}
          ><Icon icon="delete" /></IconButton>
        </Tooltip>
      </div>
    </div>
  )
}

export default Answer;
